<template>
    <div class="editor-row customize-editor-minimize">
        <div class="editor-row-title">Region Code</div>
        <a-select v-model="clone.extract_phone_number.regionCode" style="width: 100%">
            <a-select-option value="TR">Türkiye (TR)</a-select-option>
            <a-select-option value="US">United States (US)</a-select-option>
            <a-select-option value="GB">United Kingdom (GB)</a-select-option>
            <a-select-option value="DE">Germany (DE)</a-select-option>
            <a-select-option value="FR">France (FR)</a-select-option>
            <a-select-option value="RU">Russia (RU)</a-select-option>
            <a-select-option value="IN">India (IN)</a-select-option>
            <a-select-option value="CN">China (CN)</a-select-option>
            <a-select-option value="JP">Japan (JP)</a-select-option>
            <a-select-option value="KR">South Korea (KR)</a-select-option>
            <a-select-option value="BR">Brazil (BR)</a-select-option>
            <a-select-option value="AU">Australia (AU)</a-select-option>
            <a-select-option value="CA">Canada (CA)</a-select-option>
        </a-select>
        <small class="description">
            Select the region code to improve phone number detection
        </small>
    </div>
</template>

<script>
import log2 from "../../../../../../../../utils/log2";
import _ from "lodash";

const log = log2("StringFormatterExtractPhoneNumber");
export default {
    name: "StringFormatterExtractPhoneNumber",
    props: ["value"],
    data() {
        const clone = _.cloneDeep(this.value) || {
            mode: "string.extract_phone_number",
            value: "",
            extract_phone_number: {
                regionCode: "TR",
            },
        };
        return {
            clone,
        };
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
        value(newValue) {
            if (_.isEqual(newValue, this.clone)) return;
            this.clone = _.cloneDeep(newValue);
        },
    },
};
</script>

<style lang="scss" scoped>
.editor-row {
    width: 100%;

    &.customize-editor-minimize {
        display: flex;
        flex-direction: column;
        gap: 5px;
    }

    small.description {
        font-size: 10px;
        color: var(--color-text-weak-default);
    }

    .editor-row-title {
        font-weight: bold;
        font-size: 16px;
    }
}
</style> 